<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="app" @contextmenu.prevent>
    <template v-if="displaySystem">
      <router-view></router-view>
    </template>
    <cookie-notice
      @cookies-accepted="handleCookiesAccepted"
      @cookies-rejected="handleCookiesRejected"
      v-if="!showCookieNotice && !isNativeApp && canDisplayCookies"
    ></cookie-notice>
  </div>
</template>

<script>
import themeConfig from "@/../themeConfig.js";
import { refreshPageMixin } from "./components/mixins/refresh-page.mixin";
import { userInfoMixin } from "./components/mixins/user-info.mixin";
import localStorageHelper from "./helpers/local-storage-helper";
import authService from "./providers/authService";
import AppConstants from "./appConstants";
import checkDeviceTypeHelper from "./helpers/check-device-type-helper";
import store from "@/store/store";
import { EventBus } from "./event-bus";
import { getCodeLang, getCodeLangFromBrowser } from "./helpers/locale-helper";
import Vue from "vue";
import CookieNotice from "./layouts/components/CookieNotice.vue";
import { generateCorrelationId } from "./@core/utils/utils";
import biometryHelper from "./helpers/biometry-helper";

export default {
  components: {
    CookieNotice,
  },
  data() {
    return {
      displaySystem: false,
      canDisplayCookies: false,
      isDesktop: true,
    };
  },
  mixins: [refreshPageMixin, userInfoMixin],
  watch: {
    "$store.state.theme"(val) {
      this.toggleClassInBody(val);
    },
  },
  computed: {
    isS4Login() {
      return localStorageHelper.getS4Login();
    },
    isNativeApp() {
      return checkDeviceTypeHelper.isNativeApp();
    },
    showCookieNotice() {
      return this.$cookies.isKey("cookies_accepted");
      // return this.getCookieAccept || this.getCookieReject
    },
    getCookieAccept() {
      return localStorageHelper.getCookieAccepted();
    },
    getCookieReject() {
      return localStorageHelper.getCookieRejected();
    },
    isAuthenticated() {
      return this.$store.state.isAuthenticated;
    },
    isProduction() {
      return this.$store.state.isProduction;
    },
  },
  methods: {
    checkInsets() {
      const urlParams = new URLSearchParams(window.location.search);
      const top = urlParams.get("top");
      const bottom = urlParams.get("bottom");
      const left = urlParams.get("left");
      const right = urlParams.get("right");

      const element = document.documentElement;
      // const element = document.body;

      if (top) {
        this.$store.dispatch("updateInsetTop", top);
        element.style.paddingTop = `${top}px`;
      }

      if (bottom) {
        this.$store.dispatch("updateInsetBottom", bottom);
        element.style.paddingBottom = `${bottom}px`;
      }
      if (right) {
        this.$store.dispatch("updateInsetRight", right);
        element.style.paddingRight = `${right}px`;
      }

      if (left) {
        this.$store.dispatch("updateInsetLeft", left);
        element.style.paddingLeft = `${left}px`;
      }

      element.style.backgroundColor = "#00663a";

      if (top || bottom) {
        let styleTag = document.getElementById("con-vs-overrides");
        if (!styleTag) {
          styleTag = document.createElement("style");
          styleTag.id = "con-vs-overrides";
          document.head.appendChild(styleTag);
        }
        styleTag.textContent = `
      .con-vs-popup {
        padding-top: ${top}px !important;
        padding-bottom: ${bottom}px !important;
      }

      .vs-popup--background {
        background-color: transparent !important;
      }
    `;
      }
    },
    getOneSignalId() {
      biometryHelper.waitGetOneSignalID((onesignalID) => {
        if (onesignalID) {
          console.log(`[onesignalID] ${onesignalID}`);
          // alert(`[onesignalID] ${onesignalID}`);
          localStorageHelper.setOneSignalID(onesignalID);
        }
      });
    },
    updateTypeDevice() {
      // console.log('[updateTypeDevice]', window.innerWidth)
      this.isDesktop = window.innerWidth > window.innerHeight;
      // if (screen.orientation.type.indexOf('landscape') >= 0) {
      //     isDesktop = true;
      // }
      // const isDesktop = checkDeviceTypeHelper.isMobileOrDesktop() === AppConstants.DEVICE_TYPE_DESKTOP;
      const previousValueDesktop = this.$store.state.isDesktop;
      this.$store.commit("UPDATE_DEVICE_IS_DESKTOP", this.isDesktop);
      this.updateMobilePage(this.isDesktop);

      // console.log('[updateTypeDevice][previousValueDesktop]',previousValueDesktop);
      // console.log('[updateTypeDevice][isDesktop]',isDesktop);
      // console.log('[updateTypeDevice]',previousValueDesktop != isDesktop);
      if (previousValueDesktop != this.isDesktop) {
        console.log("change device type");
        this.updateView();
      }
    },
    updateView() {
      try {
        this.displaySystem = false;
        setTimeout(() => {
          this.displaySystem = true;
          this.$forceUpdate();
        }, 500);
      } catch (error) {}
    },
    handleCookiesAccepted() {
      localStorageHelper.setCookiesAccepted();
      this.injectSafrasGoogleScript();
    },
    handleCookiesRejected() {
      localStorageHelper.setCookiesRejected();
    },
    leavingPage(e) {
      alert("leavingPage");
    },
    redirectUnauthorizedDevices(isDesktop) {
      // if (isDesktop) {
      //   if (window.location.href.indexOf('mobile.safras.com.br') > 0) {
      //     window.location.href = '/error-mobile.html';
      //   }
      // }
    },
    closeModal() {},
    preventKeyPress(e) {
      console.log(e);
    },
    updateMobilePage(isDesktop) {
      if (!isDesktop) {
        document.body.classList.remove("desktop");
        document.body.classList.add("mobile");
      } else {
        document.body.classList.add("desktop");
        document.body.classList.remove("mobile");
      }
    },
    toggleClassInBody(className) {
      if (className == "dark") {
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
        document.body.classList.add("theme-dark");
      } else if (className == "semi-dark") {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        document.body.classList.add("theme-semi-dark");
      } else {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
      }
    },
    handleWindowResize() {
      this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);
      this.updateTypeDevice();
    },
    handleScroll() {
      this.$store.commit("UPDATE_WINDOW_SCROLL_Y", window.scrollY);
    },
    injectScript(script, src) {
      const node = document.createElement("script");
      node.type = "text/javascript";
      node.async = false;
      node.src = src;
      document.body.appendChild(node);
    },
    bindDeviceReady() {
      console.log("[bindDeviceReady]");
      localStorage.setItem("deviceId", undefined);
      document.addEventListener("deviceready", this.deviceReady, false);
    },
    preventBackButton() {
      if (checkDeviceTypeHelper.isPlatformAndroid()) {
        document.addEventListener(
          "backbutton",
          function (e) {
            e.preventDefault();
          },
          false
        );
      }
    },
    deviceReady() {
      console.log("[deviceReady]");
      // alert(`[deviceReady]`);
      this.preventBackButton();
      this.initPushwoosh();
    },
    initPushwoosh() {
      console.log("[initPushwoosh]");
      // alert(`[initPushwoosh]`);
      const pushwoosh = cordova.require(
        "pushwoosh-cordova-plugin.PushNotification"
      );

      document.addEventListener("push-notification", function (event) {
        console.log(`isAuthenticated: ${store.state.isAuthenticated}`);
        if (!store.state.isAuthenticated) {
          console.log("erro: nao autenticado");
          return;
        }
        const notification = event.notification;
        console.log(notification);
        if (notification.userdata && notification.userdata.custom) {
          const payload = notification.userdata.custom;
          if (payload.action === "openPage") {
            EventBus.$emit(
              AppConstants.BUS_EVENT_OPEN_NEWS_DETAIL,
              notification.userdata.custom
            );
          }
        }
      });
      const appId = this.$config.pushwoosh_app_id;
      const projId = this.$config.pushwoosh_project_id;

      pushwoosh.onDeviceReady({
        appid: appId,
        projectid: projId,
      });

      const that = this;
      console.log("[pushwoosh][registerDevice] init register");
      // alert('[pushwoosh][registerDevice] init register');
      pushwoosh.registerDevice(
        function (token) {
          console.log(
            "[pushwoosh][registerDevice] success register with token ",
            token
          );
          // alert(`[registerDevice]`);
          that.saveDeviceId(pushwoosh);
        },
        function (status) {
          console.warn(
            JSON.stringify(["failed to register deviceID ", status])
          );
          // console.log('registerDevice Error');
          // console.log(status);
        },
        that
      );
    },
    saveDeviceId(pushwoosh) {
      console.log(["[pushwoosh][saveDeviceId]"]);
      const that = this;
      pushwoosh.getPushwooshHWID(function (deviceId) {
        console.log("[deviceId]", deviceId);
        // alert(`[deviceID] ${deviceId}`);
        if (deviceId && deviceId !== "undefined") {
          localStorage.setItem("deviceId", deviceId);
        }
      }, that);
    },
    injectCordova() {
      try {
        if (checkDeviceTypeHelper.isPlatformAndroid()) {
          this.bindDeviceReady();
          const srcCordova = `${this.$config.URL_MOBILE}/cordova/android/cordova.js`;
          this.injectScript("cordova.js", srcCordova);
        } else if (checkDeviceTypeHelper.isPlatformIOS()) {
          this.bindDeviceReady();
          const srcCordova = `${this.$config.URL_MOBILE}/cordova/ios/cordova.js`;
          this.injectScript("cordova.js", srcCordova);
        }
      } catch (error) {
        console.info(
          "An error occurred while injecting Cordova script:",
          error.message
        );
      }
    },
    injectSoundCloudScript() {
      let soundcloudScript = document.createElement("script");
      soundcloudScript.setAttribute(
        "src",
        "https://w.soundcloud.com/player/api.js"
      );
      document.head.appendChild(soundcloudScript);
    },
    injectSafrasGoogleScript() {
      // removed
      return;
      if (this.isProduction) {
        let script = document.createElement("script");
        script.setAttribute("src", "/safras-scripts.js");
        document.head.appendChild(script);
      }
    },
    updateCurrentSessionBeforeUnload() {
      if (localStorageHelper.getLogoutOldSession() == "true") {
        localStorageHelper.updateLogoutOldSession(false);
      } else {
        localStorageHelper.setCurrentBrowserSession(false);
      }
    },
    closeOldSession(event) {
      if (event.key == AppConstants.LOCAL_STORAGE_EVENT_CLOSE_SESSION) {
        if (event.newValue.toString() == "true") {
          // localStorageHelper.setCurrentBrowserSession(true);
          // localStorageHelper.updateLogoutOldSession(false);
          window.location.href = "about:blank";
        }
      }
    },
    changePageElements() {
      if (themeConfig.client == AppConstants.PLATFORM_CLIENT.CMA) {
        document.title = "Plataforma Agência CMA";
        document.getElementById(
          "favicon"
        ).href = `${this.$config.URL_PRODUCTION}/favicon-cma.ico`;
        document.getElementById(
          "img-loading-logo"
        ).href = `${this.$config.URL_PRODUCTION}/logo-cma.svg`;

        // this.$vs.theme({
        //   primary:'rgb(168,208,68)'
        // });
        return;
      } else if (themeConfig.client == AppConstants.PLATFORM_CLIENT.SAFRAS) {
        document.title =
          "SAFRAS & Mercado - Consultoria líder do agronegócio brasileiro";
        document.getElementById(
          "favicon"
        ).href = `${this.$config.URL_PRODUCTION}/favicon-safras.ico`;
        document.getElementById(
          "img-loading-logo"
        ).href = `${this.$config.URL_PRODUCTION}/logo-safras.svg`;
        this.$vs.theme({
          primary: "rgb(69,140,94)",
        });
        return;
      }
      document.title = "Plataforma CMA";
      document.getElementById(
        "favicon"
      ).href = `${this.$config.URL_PRODUCTION}/favicon.ico`;
      document.getElementById(
        "img-loading-logo"
      ).href = `${this.$config.URL_PRODUCTION}/logo.svg`;
    },
    createCorrelationId() {
      const corrId = generateCorrelationId();
      console.log(`[CorrelationID] Generate new correlationId: ${corrId}`);
      this.$store.dispatch("updateCorrelationId", corrId);
    },
  },
  async mounted() {
    console.log("[app mounted]");
  },
  async created() {
    console.log("[app created]");
    this.checkInsets();
    if (process.env.NODE_ENV == "production") {
      Vue.prototype.$config = await authService.getConfig(
        process.env.BASE_URL + "config.json",
        {
          auth: {
            username: "safras-platform-user",
            password: "ccb4d652e79d210ff834e4de956bd7d3",
          },
        }
      );
      // this.initVersionCheck('appversion.json');
    } else {
      const configResp = await fetch(process.env.BASE_URL + "config.json");
      Vue.prototype.$config = await configResp.json();
    }
    // console.log('[loadconfig]', this.$config);
    this.displaySystem = true;
    this.canDisplayCookies = true;
    this.changePageElements();
    this.initCheckUserInfo();
    this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

    // const isDesktop = checkDeviceTypeHelper.isMobileOrDesktop() === AppConstants.DEVICE_TYPE_DESKTOP;
    // const isDesktop = !checkDeviceTypeHelper.isNativeApp();
    // this.redirectUnauthorizedDevices(isDesktop);
    // this.$store.commit("UPDATE_DEVICE_IS_DESKTOP", isDesktop);
    this.$store.commit(
      "UPDATE_IS_PRODUCTION",
      window.location.href.indexOf(this.$config.URL_PRODUCTION) === 0
    );
    // console.log('[app created isDesktop]', isDesktop)
    // localStorageHelper.checkExisteSessioninBrowser();
    this.updateTypeDevice();
    window.addEventListener("resize", this.handleWindowResize);
    window.addEventListener("scroll", this.handleScroll);

    const localeCode = localStorageHelper.getLocaleLocalStorage();
    if (localeCode) {
      this.$i18n.locale = getCodeLang(localeCode);
    } else {
      this.$i18n.locale = getCodeLangFromBrowser();
    }

    if (!this.isDesktop && checkDeviceTypeHelper.isNativeApp()) {
      if (checkDeviceTypeHelper.isReactApp()) {
        biometryHelper.initData();
        biometryHelper.setLanguage();
        this.getOneSignalId();
      } else {
        this.injectCordova();
      }
    }

    // if (checkDeviceTypeHelper.isNativeApp() && !checkDeviceTypeHelper.isReactApp()) {
    //   this.injectCordova();
    // }

    // mounted

    this.injectSoundCloudScript();

    // if (this.getCookieAccept) {
    //   this.injectSafrasGoogleScript();
    // }

    this.toggleClassInBody(themeConfig.theme);

    // WDMA IFRAME
    this.$store.dispatch(
      "updateUserAuthenticated",
      authService.isAuthenticated()
    );

    // window.addEventListener('beforeunload', this.updateCurrentSessionBeforeUnload)
    // window.addEventListener('storage', this.closeOldSession)
    if (authService.isAuthenticated()) {
      this.createCorrelationId();
      const currentRights = await authService.getMainMenu(
        new URLSearchParams()
      );
      localStorageHelper.updateUserRights(currentRights);
    }

    // Check device display on ios
    if (checkDeviceTypeHelper.isPlatformIOS()) {
      this.$store.dispatch("updateMobileIos", true);
    }

    EventBus.$on("onS4Login", () => {
      this.canDisplayCookies = false;
    });

    this.canDisplayCookies = !this.isS4Login;

    // console.log('updating cookies to: ', this.getCookieReject != 'true');
    this.$cookies.set("cookies_accepted", this.getCookieReject != "true");
    // console.log(this.canDisplayCookies);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleWindowResize);
    window.removeEventListener("scroll", this.handleScroll);
    EventBus.$off("onS4Login");
  },
  beforeDestroy() {
    // alert('leavingPlatform');
    document.body.style.paddingTop = "";
    document.body.style.paddingBottom = "";
    document.body.style.backgroundColor = "";
  },
};
</script>

<style lang="scss" scoped>
.refresh-container {
  width: 15%;
  position: fixed;
  bottom: 10px;
  background-color: #fff;
  right: 15px;
  padding: 25px;
  -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.05);
  -moz-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.05);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.05);
}
</style>
